module.exports = __webpack_public_path__ + "static/media/br.762fd741.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/br.png
// module id = 1805
// module chunks = 0